import { render, staticRenderFns } from "./voice-room-form.vue?vue&type=template&id=35401f47&scoped=true&"
import script from "./voice-room-form.vue?vue&type=script&lang=js&"
export * from "./voice-room-form.vue?vue&type=script&lang=js&"
import style0 from "./voice-room-form.vue?vue&type=style&index=0&id=35401f47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35401f47",
  null
  
)

export default component.exports